import chatLogApi from "../../api/chat_logs";
import * as mutationTypes from "../mutation-types";

const state = {
  chatLogs: [],
  hasUnreadMessages: false,
  latestMessageId: 0,
};

const getters = {
  chatLogs: state => state.chatLogs,
  hasUnreadMessages: state => state.hasUnreadMessages,
  latestMessageId: state => state.latestMessageId,
};

const actions = {
  fetchChatLogs({ commit }, params) {
    return new Promise((resolve, reject) => {
      chatLogApi.fetchChatLogs(chatLogs => {
        commit(mutationTypes.ASSIGN_CHAT_LOGS, { chatLogs });
        resolve();
      },
      () => {
        reject();
      }, params);
    });
  },

  addChatLog({ commit }, chatLog ){
    return new Promise((resolve, reject) => {
      commit(mutationTypes.ADD_CHAT_LOG, { chatLog });
      resolve();
    });
  },

  markAsRead(_, params) {
    return new Promise((resolve, reject) => {
      chatLogApi.markAsRead(() => {
        resolve();
      },
      () => {
        reject();
      }, params);
    });
  },

  post({ commit }, params) {
    return new Promise((resolve, reject) => {
      chatLogApi.post(() => {
        resolve();
      },
      (error) => {
        reject(error);
      }, params);
    });
  },

  clearChatLogs({ commit }) {
    let chatLogs = [];
    commit(mutationTypes.ASSIGN_CHAT_LOGS, { chatLogs });
  }
};

const mutations = {
  [mutationTypes.ASSIGN_CHAT_LOGS](state, { chatLogs }) {
    const messages = Array.isArray(chatLogs?.messages) ? chatLogs.messages : [];

    state.chatLogs = messages;
    state.hasUnreadMessages = !!chatLogs?.hasUnreadMessages;
    if (state.chatLogs.length > 0) {
      state.latestMessageId = state.chatLogs.slice(-1)[0]["id"];
    } else {
      state.latestMessageId = 0;
    }
  },
  [mutationTypes.ADD_CHAT_LOG](state, { chatLog }) {
    if (!Array.isArray(state.chatLogs)) {
      state.chatLogs = [];
    }

    // 同じメッセージIDのリアルタイムイベント重複を無視する。
    if (chatLog && chatLog.id != null && state.chatLogs.some(log => log.id === chatLog.id)) {
      return;
    }

    state.chatLogs.push(chatLog);
    state.latestMessageId = chatLog["id"];
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
